import React, { Suspense, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// UI components
import MB_Logo from "../../assets/images/mb_logo.png";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form, Row, Col, Container, Card, Spinner } from "react-bootstrap";

// Utilities
import { Group, log } from "../../utils/logger";

import LogInMicrosoft from "./LogIn.Microsoft";
import Copyright from "../../components/Env/Copyright";

// State
import { getTenants } from "../../state/actions/tenants";
import { loginWithPassword, loadUser, ssoUser } from "../../state/actions/user";

// Modal
import ModalTenants from "./Modal.Tenants";

const { ENABLE_SIGN_UP } = process.env;

const LoggerGroup = new Group("Sign In");

const Page = ({ user, loginWithPassword, loadUser, ssoUser, getTenants }: any) => {
  const { isAuthenticated, userToken, isSsoAuthenticated, ssoPayload } = user;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    LoggerGroup.emit("Loaded");
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      setEmail("");
      setPassword("");
    }

    if (!isAuthenticated && userToken) {
      LoggerGroup.emit("SignIn: Logging in from existing token").end();
      loadUser();
    }
  }, [isAuthenticated, userToken, loadUser]);

  useEffect(() => {
    if (isSsoAuthenticated && ssoPayload.authData) {
      if (
        ssoPayload.authData.account &&
        (ssoPayload.authData.account.username.endsWith("linkmobility.com") ||
          ssoPayload.authData.account.username.endsWith("messagebroadcast.com"))
      ) {
        getTenants(ssoPayload.vendor, ssoPayload.authData);
      } else {
        ssoUser(ssoPayload.vendor, ssoPayload.authData);
      }
    }
  }, [isSsoAuthenticated, ssoPayload, ssoUser, getTenants]);

  function handleSubmit(e: any) {
    e.preventDefault(); // Prevent page from submitting

    const inputEmail = e.target.email.value;
    const inputPassword = btoa(e.target.password.value);

    if (inputEmail.endsWith("linkmobility.com") || inputEmail.endsWith("messagebroadcast.com")) {
      setEmail(inputEmail);
      setPassword(inputPassword);

      // TODO: verify if the user is set up in global (prefportal) table
      getTenants(null, null, inputEmail, inputPassword);
    } else {
      const user = {
        email: inputEmail,
        password: inputPassword,
      };

      log("Sign In Form", user);
      // login normally
      loginWithPassword({ ...user });
    }
  }

  return (
    <Container data-testid="sign-in">
      <ModalTenants email={email} password={password} />

      <Row className="justify-content-md-center align-items-center" style={{ height: "90vh" }}>
        <Col md={8} xl={6}>
          <Card>
            <Card.Img
              variant="top"
              src={MB_Logo}
              style={{ width: "50%" }}
              className="mx-auto mt-3"
            />

            <Card.Body className="text-center pb-0">
              <FontAwesomeIcon icon={faLock} size="2x" />

              <Card.Title>Sign In</Card.Title>
            </Card.Body>

            <Card.Body>
              <Form noValidate onSubmit={handleSubmit}>
                <Form.Group>
                  <Form.Label>Email Address</Form.Label>

                  <Form.Control
                    id="email"
                    type="email"
                    name="email"
                    placeholder="sample@email.com"
                    autoComplete="email"
                    autoFocus
                    required
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>Password</Form.Label>

                  <Form.Control
                    id="password"
                    type="password"
                    name="password"
                    placeholder="********"
                    autoComplete="current-password"
                    autoFocus
                    required
                  />
                </Form.Group>

                {/*
                  <Form.Group className="mb-3" controlId="formBasicCheckbox">
                    <Form.Check type="checkbox" label="Remember Me" value="remember" />
                  </Form.Group>
                */}

                <Button type="submit" color="primary" block>
                  Sign In
                </Button>

                <Row>
                  <Col>
                    <Link to="/auth/forgot-password">
                      <small>Forgot password?</small>
                    </Link>
                  </Col>

                  {ENABLE_SIGN_UP && (
                    <Col className="text-right">
                      <Link to="/auth/register">
                        <small>Don't have an account? Sign Up</small>
                      </Link>
                    </Col>
                  )}
                </Row>
              </Form>
            </Card.Body>

            <Card.Body className="text-center">
              <hr />

              <LogInMicrosoft />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mt-8">
        <Col>
          <Copyright />
        </Col>
      </Row>
    </Container>
  );
};

// loading component for suspense fallback
const Loader = () => (
  <div className="d-flex justify-content-center align-items-stretch" style={{ height: "90vh" }}>
    <div className="my-auto">
      <Spinner animation="border" role="status" variant="primary" />
    </div>
  </div>
);

function SignIn(props: any) {
  return (
    <Suspense fallback={Loader}>
      <Page {...props} />
    </Suspense>
  );
}

const mapStateToProps = (state: any) => ({
  user: state.user,
  loading: state.globals.block_ui,
});

export default connect(mapStateToProps, { loginWithPassword, loadUser, ssoUser, getTenants })(
  SignIn
);
